<template lang="html">
  <div class="mx-auto pt-12 container">
    <div v-if="user.profile.isAdmin">
    <h2 class="block w-full mb-8 w-full text-center md:text-left text-3xl border-b pb-4">Insights</h2>
    <div class="md:flex ">
    <Users class="mr-8" :count="getUsersCount" :heros="heros" :users="users" />
    <Heros :users="users" :heros="heros" class="w-full md:w-1/3" />
    <Roles :users="users" :heros="heros" class="w-full md:w-1/3" />
    </div>
    </div>
    <div v-else>
      <h2 class="block w-full mb-8 w-full text-center md:text-left text-3xl border-b pb-4">How did it come to this?</h2>
      <p>We're sorry but you do not have the persmissions to view this page</p>
    </div>
  </div>
</template>

<script>
  import firebase from "firebase/app"
  import { mapState } from "vuex"
  import Users from "@/components/admin/Users.vue"
  import Heros from "@/components/admin/Heros.vue"
  import Roles from "@/components/admin/Role.vue"
  export default {
    components: {
      Users,
      Heros,
      Roles
    },
    data () {
      return {
          users: [],
          heros: []
      }
    },
    mounted() {
      this.getUserData()
    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
        ...mapState({
        user: "user"
      }),
      getUsersCount() {
        let users = this.users
        return users.length
      }
    },
    methods: {
      getUserData() {
        var firestore = firebase.firestore();
        var vm = this;
        vm.users = []
        vm.heros = []
        firestore.collection("analytics").doc("records")
        .onSnapshot(function(doc) {
            vm.users = doc.data().users;
            vm.heros = doc.data().heros;
            //console.log(doc.data())
        }.bind(vm));
      }
    }
  }
</script>
